<template lang="html">

  <form id="formContacto" class="column-center" @submit.prevent="validateBeforeSubmit">

    <div class="contenedor-input">
      <label for="">Nombre</label>
      <input type="text" class="input-text" v-validate="'required'" name="nombre" placeholder="Nombre*" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">Apellidos</label>
      <input type="text" class="input-text" v-validate="'required'" name="apellidos" placeholder="Apellidos*" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('nombre') }}</span>
    </div>


    <div class="contenedor-input">
      <label for="">Email</label>
      <input type="text" class="input-text" v-validate="'required|email'" name="email"
        :placeholder="$t('formulario.email')+'*'" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('email') }}</span>
    </div>

    <div class="contenedor-input">
      <label for="">Teléfono</label>
      <input type="text" class="input-text" v-validate="'length:9'" name="telefono"
        :placeholder="$t('formulario.telefono')" />
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('telefono') }}</span>
    </div>


    <div class="contenedor-input">
      <label for="">Mensaje</label>
      <textarea :placeholder="$t('formulario.mensaje')+'*'" name="mensaje" v-validate="'required'"></textarea>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('mensaje') }}</span>
    </div>

    <div class="contenedor-input" v-if="legaltext[0]">
      <input type="checkbox" class="input-check" v-validate="'required'" id="politica-contacto" name="politica"
        :placeholder="$t('formulario.telefono')" @change="generatehash" :hash="legaltext[0].hash"/>
      <label for="politica-contacto" v-html="legaltext[0].Texto"></label>
      <span :class="['error',{'animated shake' : clicked}]" v-if="clicked">{{ errors.first('politica') }}</span>
    </div>

    <div class="contenedor-input" v-if="legaltext[1]">
      <input type="checkbox" class="input-check" id="newsletter" name="newsletter" @change="generatehash" :hash="legaltext[1].hash"/>
      <label for="newsletter" v-html="legaltext[1].Texto"></label>
    </div>

    <button class="btn with-border" v-if="!enviado">{{$t('formulario.enviar')}}</button>
    <h2 v-if="enviado">Enviado</h2>

    <input type="hidden" name="hash" id="hash" v-model="hash_1">
    <input type="hidden" name="hash_2" id="hash_2" v-model="hash_2">
    <input type="hidden" name="mia" value="FM-FUNDACIONTOMASPASCUAL CONTACTOWEB DOUBLEDOT">

  </form>

</template>

<script lang="js">


  import Vue from 'vue';
  import VeeValidate from 'vee-validate';

  Vue.use(VeeValidate);

  import { mapGetters, mapActions } from 'vuex'

  import axios from 'axios';

  export default {
    name: 'formulario',
    props: [],
    mounted() {
      this.setdata();
    },
    data() {
      return {
        clicked: false,
        enviado: false,
        legaltext: [],
        hash_1: '',
        hash_2: '',
        legales :[
          {
            label: "politica-contacto",
            input: "politica-contacto",
            clave: "PP-FUNDACIONTOMASPASCUAL CONTACTOWEB ES DOUBLEDOT",
            enlaces: [
              `/politica-de-privacidad?area_mkt_desc=Fundación%20TPPGC&texto_extendido=1&clave=PP-FUNDACIONTOMASPASCUAL CONTACTOWEB ES DOUBLEDOT`,
            ]
          },
          {
            label: "newsletter",
            input: "newsletter",
            clave: "EC-FUNDACIONTOMASPASCUAL CONTACTOWEB ES DOUBLEDOT",
          }
        ]
      }
    },
    methods: {
      ...mapActions(['sendContacto']),
      validateBeforeSubmit: function () {

        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if (canSend) {
            this.sendContacto($("#formContacto").serialize())
              .then(result => {
                if (result) {
                  this.enviado = true;
                  this.$validator.reset();
                  $("#formContacto")[0].reset()
                }
              });
          }
        });
      },
      setdata() {
  

        this.legales.forEach(texto => {
          axios.get(`https://apin-datahub-prod-001.azure-api.net/api/texto-legal/${texto.clave}?area_mkt_desc=Fundación%20TPPGC`).then(result => {
            var dom = document.createElement('span');
            dom.innerHTML = result.data.Texto;

            if (dom.querySelector('a')) {
              dom.querySelector('a').href = texto.enlaces[0];
            }
            
            result.data.Texto = dom.innerHTML;


            result.data.hash = result.data.Texto_Legal_Id + ";" + result.data.Hash_Version_Id + ";" + 'FUNDACION TOMAS PASCUAL';

            this.legaltext.push(result.data);
          });
        })

      },
      generatehash(event) {
        var status = {};
        var hashValue = "";

        this.legales.forEach((texto) => {
          status[texto.input] = document.getElementById(texto.input).checked;
        });



        Object.keys(status).forEach((check) => {          
          hashValue += (status[check]) ? $(`#${check}`).attr('hash') + "#" : "";
        });
        
        

        hashValue = hashValue.substr(0, hashValue.length - 1);
        this.hash_1 = hashValue.substr(0, 500);
        if (hashValue.length > 500) {
          this.hash_2 = hashValue.substr(
            500,
            hashValue.length
          );
        }
      }
    },
    computed: {

    }
  }
</script>

<style scoped lang="scss">
  h2 {
    text-transform: uppercase;
    font-family: "Conv_Alwyn Bold";
    color: #b91e2b;
  }
</style>


// WEBPACK FOOTER //
// src/components/view-parts/contacto/formulario.vue